(ns teamoesterreich.admin-mode.data.lr-feeds
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]

            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))


(defonce LR_FEED_FAQ backend/LR_FEED_FAQ)
(defonce LR_FEED_NEWS backend/LR_FEED_NEWS)

(defn date-to-restDate [d]
  (let [t (clojure.string/replace (str (.toISOString d)) #"\.|:|-" "")]
    (str (subs t 0 15) "." (subs t 15))))


(defn get-lr-feed-list [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/lr-feed")
              (fn [r-list status]
                ;(log/debug "get-blog done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (map (fn [e] [(get e "lr-feed-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                    )))))

(defn >new-lr-feed-item [name feed-uuid finished-fn]
  (ajax/auth-post> (backend/get-auth)  (str  backend/BASE_URL "/lr-feed-item" )
              (ajax/serialize {:lrFeedItem-active true
                               :lrFeedItem-title name
                               :lrFeedItem-feed-uuid feed-uuid
                               :lrFeedItem-published false
                               :lrFeedItem-date (date-to-restDate (js/Date.))
                               :lrFeedItem-content ""})
              (fn [data status]
                (when (= status 200)
                  (finished-fn
                    (into {} (clojure.walk/keywordize-keys (js->clj (json/parse data))))
                    )))))


(defn >lr-feed-item-edit-img [lr-feed-item-uuid lr-feed-item-imageUri finished-fn]
  (ajax/auth-put> (backend/get-auth)  (str  backend/BASE_URL "/lr-feed-item/" lr-feed-item-uuid)
             (ajax/serialize (merge {:lrFeedItem-uuid lr-feed-item-uuid}
                                    {:lrFeedItem-thumbnail lr-feed-item-imageUri}))
             finished-fn))

(defn >lr-feed-item-edit [lr-feed-item-uuid lr-feed-item finished-fn]
  (ajax/auth-put> (backend/get-auth)  (str  backend/BASE_URL "/lr-feed-item/" lr-feed-item-uuid)
             (ajax/serialize (merge lr-feed-item
                                    {:lrFeedItem-uuid lr-feed-item-uuid}))
             finished-fn))

(defn get-lr-feed-item-list [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/lr-feed-item")
              (fn [r-list status]
                ;(log/debug "get-blog done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (map (fn [e] [(get e "lrFeedItem-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                    )))))

(defn get-lr-feed-item [blockUuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/lr-feed-item/" blockUuid)
              (fn [r-list status]
                ;(log/debug "get-blog done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                    )))))
